<template>
  <article id="ingredient-article">
    <input type="text" class="title" v-model="ingredientTitle" />
    <div class="similarities">
      <p class="similarity-title">Similarités ({{ similarities.length }})</p>
      <button
        class="similarity"
        v-for="(similarity, simIndex) in similarities"
        :key="simIndex"
        @click="() => onSimilarityChoose(simIndex)"
      >
        {{ similarity.title }}
      </button>
    </div>

    <div class="btn-containers">
      <button
        class="button-shadow success"
        v-if="showValidateBtn"
        @click="validate"
      >
        Valider cet Ingrédient
      </button>
      <button class="button-shadow warning" v-else @click="rename">
        Renommer et valider
      </button>
    </div>
  </article>
</template>

<script>
import ingredientsService from '../../../services/ingredients.service';

export default {
  props: {
    ingredient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ingredientTitle: '',
      similarities: [],
    };
  },
  async created() {
    this.ingredientTitle = this.ingredient.title;
    this.similarities = [];

    const lowerCase = this.ingredientTitle.toLowerCase();
    const upperCase = this.ingredientTitle.toUpperCase();
    const firstUpperCase =
      this.ingredientTitle.charAt(0).toUpperCase() +
      this.ingredientTitle.slice(1);
    const withoutAccents = this.ingredientTitle
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const isAllLowerCase = this.ingredientTitle === lowerCase;
    const isAllUpperCase = this.ingredientTitle === upperCase;
    const isFirstUpperCase = this.ingredientTitle === firstUpperCase;
    const containsAccent = this.ingredientTitle === withoutAccents;

    // On cherche le même qui commence pareil
    ingredientsService
      .searchIngredients(this.ingredientTitle)
      .then((ingToMerge) => {
        this.similarities = this.similarities.concat(ingToMerge);
      });

    // On cherche les mêmes ingrédients en minuscule
    if (!isAllLowerCase) {
      ingredientsService.searchIngredients(lowerCase).then((ingToMerge) => {
        this.similarities = this.similarities.concat(ingToMerge);
      });
    }
    // On cherche les mêmes ingrédients en majuscule
    if (!isAllUpperCase) {
      ingredientsService.searchIngredients(upperCase).then((ingToMerge) => {
        this.similarities = this.similarities.concat(ingToMerge);
      });
    }
    // On cherche les mêmes ingrédients juste la première lettre en majuscule
    if (!isFirstUpperCase) {
      ingredientsService
        .searchIngredients(firstUpperCase)
        .then((ingToMerge) => {
          this.similarities = this.similarities.concat(ingToMerge);
        });
    }
    // On cherche les mêmes ingrédients sans les accents
    if (!containsAccent) {
      ingredientsService
        .searchIngredients(withoutAccents)
        .then((ingToMerge) => {
          this.similarities = this.similarities.concat(ingToMerge);
        });
    }
  },
  methods: {
    validate() {
      ingredientsService.validate(this.ingredient).then(() => {
        this.$emit('remove');
      });
    },
    rename() {
      ingredientsService
        .renameAndValidate(this.ingredient, this.ingredientTitle)
        .then(() => {
          this.$emit('remove');
        });
    },
    onSimilarityChoose(simIndex) {
      const similarity = this.similarities[simIndex];
      ingredientsService
        .mergeWithSimilarity(this.ingredient, similarity)
        .then(() => {
          this.$emit('remove');
        });
    },
  },
  computed: {
    showValidateBtn() {
      // Validate si on a pas changé le titre
      return this.ingredientTitle === this.ingredient.title;
    },
  },
};
</script>

<style lang="scss" scoped src="./Ingredient.scss"></style>
